import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';

export const useDeleteNotesMutation = (reservationIds: string[]) =>
    useRepositoryMutation('reservations', 'deleteNotes', {
        transformParams: ({ noteIds }: { noteIds: string[] }) => ({
            reservationIds,
            serviceOrderNoteIds: noteIds,
        }),
        onSuccess: () => showSuccessAlert({ description: lt('NotesDeletedSuccessMessage') }),
    });
